import React, { Component } from 'react';
import HomeHeader from "./HomeHeader";

import '../scss/style.scss';

class Home extends Component{
  constructor(props) {
    super(props);
    this.state = {
      testimonialIndex: 0,
      testimonials: [
        {
          quote: "Kimsha from Essential Safety did a great job. She came to my office and set up gave the training, and my guys finished and they really learned a lot.",
          author: "William",
          company: "ESC Cabling INC.",
          rating: 5
        },
        {
          quote: "Kimsha from Essential Safety is Fantastic. Not only did I go to get my 30 hour, I have sent all of my employees. She has even come to my office to handle the training. You won't find anyone better A++",
          author: "Everett",
          company: "Urban Ecospaces, INC.",
          rating: 5
        },
        {
          quote: "Kimsha from Essential Safety is so accommodating. I wasn't sure what I wanted, she came to my office and sat down with me to figure out my needs. I was grateful for the resolution and the prompt instruction she gave my staff, Thanks.",
          author: "Rosemary",
          company: "URI INC.",
          rating: 5
        },
      ]
    }
  }

  componentDidMount() {
    this.startTestimonials();
  }

  componentWillUnmount()  {
    clearInterval(this.state.timerId);
  }

  startTestimonials() {
    let counter = 0;

    const timerId = setInterval( () => {
      counter += 1;
      if (counter <= 1) {
        this.fadeIn();
      }else if (counter === 29) {
        this.fadeOut();
      } else if (counter > 29){
        this.nextQuote();
        counter = 0;
      }

    }, 500);

    this.setState(() => ({
      timerId: timerId
    }));
  }

  nextQuote() {
    this.setState((prevState) => {
      const nextIndex = prevState.testimonials.length - 1 === prevState.testimonialIndex ? 0 : prevState.testimonialIndex + 1;
      return {testimonialIndex: nextIndex}
    })
  }

  fadeIn() {
    const testimonialsElem = document.getElementById('testimonials');
    testimonialsElem.classList.add('fadeIn');
    testimonialsElem.classList.remove('fadeOut');
  }

  fadeOut() {
    const testimonialsElem = document.getElementById('testimonials');
    testimonialsElem.classList.add('fadeOut');
    testimonialsElem.classList.remove('fadeIn');
  }


  render() {
    const currentTestimonial = this.state.testimonials[this.state.testimonialIndex];
    
    return (
      <div className="App">
        <HomeHeader title="WE HAVE YOUR SAFETY RIGHT IN THE PALM OF OUR HANDS" pageName="Home"/>
        
        <div className="home-content-wrapper">
          <div className="home-decorative-elements"></div>
          
          <div className="pageLayout homeGistContainer">
            <div className="homeGistSectionWrap">
              <div className="section-icon">
                🛡️
              </div>
              <h3 className="homeGistHeader">
                People always want <span>security</span>; here at <span>Essential Safety Communication</span> we can give you that!
              </h3>
            </div>
            
            <div className="homeGistSectionWrap">
              <div className="section-icon">
                ⭐
              </div>
              <p className="homeGistText">
                We stand by our services; we work hard to make sure you're <strong>safe to the greatest degree possible</strong>. We will provide your employees knowledge to ensure all mechanical and physical aspects are covered for personal safety and health. We offer a <strong>full spectrum of services</strong> in keeping with the highest standards.
              </p>
            </div>
          </div>
          
          <div className="pageLayout homeTestimonialsContainer">
            <div className="homeTestimonialsHeaderWrap">
              <h3 className="homeTestimonialsHeader">
                What Our Clients Say
              </h3>
              <hr />
            </div>
            
            <div id="testimonials" className="homeTestimonialsQuoteWrap">
              <div className="testimonial-rating">
                {[...Array(currentTestimonial.rating)].map((_, i) => (
                  <span key={i} className="star">⭐</span>
                ))}
              </div>
              
              <q id="testimonialsQuote" className="homeTestimonialsQuote">
                {currentTestimonial.quote}
              </q>
              
              <cite>
                <span id="testimonialsAuthor" className="homeTestimonialsAuthor">
                  {currentTestimonial.author}
                </span>
                <span id="testimonialsCompany" className="homeTestimonialsCompany">
                  {currentTestimonial.company}
                </span>
              </cite>
              
              <div className="testimonial-indicators">
                {this.state.testimonials.map((_, index) => (
                  <span 
                    key={index} 
                    className={`indicator ${index === this.state.testimonialIndex ? 'active' : ''}`}
                  ></span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
} 

export default Home;